import { cx, VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';
import * as styles from './styles';

type SkeletonItemTypeMap = BaseTypeMap<
  'div',
  {
    rowCount?: number;
  } & VariantProps<typeof styles.item>
>;

export type SkeletonItemProps = ComponentProps<SkeletonItemTypeMap>;

export const SkeletonItem: Component<SkeletonItemTypeMap> = forwardRef(
  function SkeletonItem({ className, rowCount = 1, ...props }, ref) {
    return (
      <>
        {[...Array(rowCount)].map((item, index) => (
          <Box
            ref={ref}
            key={index}
            className={cx(styles.item({ ...props }), className)}
          />
        ))}
      </>
    );
  }
);
